module.exports = __webpack_public_path__ + "img/setting.417a4eea.png";